/**
 * Dashboard Filters Hooks
 *
 * React Query hooks for fetching filter options
 */

import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getJobCategories, getPriorities, getUsers } from '../api/filtersApi';

/**
 * Fetch job categories for dashboard filters
 */
export function useJobCategories() {
  return useQuery({
    queryKey: queryKeys.dashboard.jobCategories(),
    queryFn: () => getJobCategories(),
    staleTime: 5 * 60 * 1000, // 5 minutes - categories don't change often
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
}

/**
 * Fetch users for assignee dashboard filters
 */
export function useUsers() {
  return useQuery({
    queryKey: queryKeys.dashboard.users(),
    queryFn: () => getUsers(),
    staleTime: 5 * 60 * 1000, // 5 minutes - users don't change often
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
}

/**
 * Fetch priorities for priority dashboard filters
 */
export function usePriorities() {
  return useQuery({
    queryKey: queryKeys.dashboard.priorities(),
    queryFn: () => getPriorities(),
    staleTime: 10 * 60 * 1000, // 10 minutes - priorities rarely change
    gcTime: 60 * 60 * 1000, // 60 minutes
  });
}
